import memoize from 'lodash/memoize';
import {checkRut, cleanRut, formatRut, cleanPpu, isAutoNew, isAutoOld, isMotoNew, isMotoOld} from './utils';

export const isString = (str) => {
    return typeof str === 'string';
};

export const isEmptyString = (str) => {
    return isNullOrUndefined(str) || str.toString().trim().length === 0;
};

export const isNullOrUndefined = (value) => {
    return value === null || value === undefined;

};

export const isAllKeyNullOrUndefined = (value = {}, omit = []) => {
    const first = Object.keys(value).find(key => !isNullOrUndefined(value[key]) && !omit.includes(key));
    return isNullOrUndefined(first);
}

export const isEmptyObject = (obj) => {
    if (isNullOrUndefined(obj)) return true;

    for (const prop in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
            return false;
        }
    }
    return true;
};

export const isSuccessResponse = (response, custom = true) => {
    return !!(response && response.data && response.status < 400);
};

export const rut = {
    checkRut: checkRut, clean: cleanRut, format: formatRut, checkNativeRut: memoize((value) => {
        const {bodyPart, checkDigitPart} = checkRut(value);
        return !!(bodyPart && +bodyPart < 50000000);
    }), checkLegalRut: memoize((value) => {
        const {bodyPart, checkDigitPart} = checkRut(value);
        return !!(bodyPart && +bodyPart > 50000000);
    })
};

export const patente = {
    verify(input, vehicleType, validator) {
        let patente = input;
        if (!vehicleType) {
            return validator.createError({message: 'Debe seleccionar el tipo de vehículo.'});
        }

        if (!patente) {
            return;
        }

        if (typeof patente !== 'string') {
            return validator.createError({message: 'Patente inválida.'});
        }

        patente = cleanPpu(patente);

        if (vehicleType === 'bike') {
            // normalize motorcycle plates
            if (isMotoOld(patente) || isMotoNew(patente)) return true
        } else {
            if (isAutoNew(patente) || isAutoOld(patente)) return true
        }

        return validator.createError({message: 'Formato de Patente inválido para el tipo de vehículo seleccionado.'});
    },
};

